// extracted by mini-css-extract-plugin
module.exports = {"sunny_header":"header_sunny_header__2C00J","headerFixed":"header_headerFixed__3yOSL"};